/**
 * Formatea un tamanio de archivo de su valor numerico en bytes, a un string que incluye la unidad mas apropiada.
 *
 * @param bytes numero a formatear.
 * @param decimals numero de decimales a utilizar.
 */
export function formatFileSize(bytes, opts = {}) {
    var _a;
    const decimals = (_a = opts.decimals, (_a !== null && _a !== void 0 ? _a : 2));
    const space = (opts.addSpace ? " " : "");
    if (bytes < 1024)
        return bytes.toFixed(decimals) + space + "B";
    const kb = bytes / 1024;
    if (kb < 1024)
        return kb.toFixed(decimals) + space + "KB";
    const mb = kb / 1024;
    if (mb < 1024)
        return mb.toFixed(decimals) + space + "MB";
    const gb = mb / 1024;
    if (gb < 1024)
        return gb.toFixed(decimals) + space + "GB";
    const tb = gb / 1024;
    if (tb < 1024)
        return tb.toFixed(decimals) + space + "TB";
    return "";
}
//# sourceMappingURL=file.js.map